import { useQuery } from '@tanstack/react-query'
import { resolveEmoji, resolveName } from './helpers'

const namespace = 'emoji'

const commonQueryOptions = {
    staleTime: Infinity,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
}

export const useEmoji = (options = {}) => {
    const shortcode = options?.shortcode
    const enabled = (options?.queryOptions?.enabled ?? true) && !!shortcode

    const { data } = useQuery({
        queryKey: [namespace, shortcode],
        queryFn: async () => {
            const [resolved] = await resolveEmoji([{ name: shortcode }])
            return resolved ?? null
        },
        ...commonQueryOptions,
        enabled
    })

    return data
}

export const useShortcode = (options = {}) => {
    const emoji = options?.emoji
    const enabled = (options?.queryOptions?.enabled ?? true) && !!emoji

    const { data } = useQuery({
        queryKey: [namespace, emoji],
        queryFn: async () => {
            const [resolved] = await resolveName([{ emoji }])
            return resolved ?? null
        },
        ...commonQueryOptions,
        enabled
    })

    return data
}